<template>
<ul class="nav my-0">
    <li id="prev-button">
        <button type="button" :disabled="current_page === 0" @click="prevPage"></button>
    </li>

    <!-- Range of pages -->

    <li id="next-button">
        <button type="button" :disabled="current_page >= pageCount -1" @click="nextPage"></button>
    </li>
</ul>
</template>

<script>
// https://medium.com/@denny.headrick/pagination-in-vue-js-4bfce47e573b
export default {
    name: "Paginator",
    props: {
        items: {
            required: true,
            type: Array,
        },
        per_page: {
            type: Number,
            required: true,
            default: 5,
        },
        page : {
            type: Number,
            default : 5,
        }
    },
    computed: {
        pageCount() {
            let l = this.items.length,
                s = this.per_page;
            return Math.ceil(l / s);
        },
        paginatedData() {
            const start = this.current_page * this.per_page,
                end = start + this.per_page;
            return this.items
                .slice(start, end);
        }
    },
    data() {
        return {
            current_page: 0,
        }
    },

    mounted() {
        this.current_page = this.page;
    },

    methods: {
        nextPage() {
            this.current_page++;
            this.$emit('next', {
                data : this.paginatedData,
                page : this.current_page
            });
        },
        prevPage() {
            this.current_page--;
            this.$emit('prev', {
                data : this.paginatedData,
                page : this.current_page
            });
        }
    },
}
</script>

<style scoped>
.nav {
    display: flex !important;
    list-style-type: none;
    padding-left: 0;
    padding-right: 0;
    width: 100%;
    display: -webkit-box;
    /* OLD - iOS 6-, Safari 3.1-6, BB7 */
    display: -ms-flexbox;
    /* TWEENER - IE 10 */
    display: -webkit-flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;

}

button{
    border: solid 1px #ccc;
    border-radius: 5px;
}

ul li#next-button button::after {
    content: "\203A";
    font-weight: 300;
    font-size: 20px;
    
    /* float: right;
    margin-right: 15px; */
}

ul li#prev-button button::before {
    content: "\2039";
    font-weight: 300;
    font-size: 20px;
    /* float: right;
    margin-right: 15px; */
}
</style>
